/** Prefix of catalogue make keys, e.g. MAKE_BMW; only these can be looked up in the catalogue. */
export const CATALOGUE_MAKE_KEY_PREFIX = 'MAKE_';
